import React from 'react';

import Room from '../room';

import L1 from './images/Loft.1.jpg';
import L2 from './images/Loft.2.jpg';
import L3 from './images/Loft.3.jpg';
import L4 from './images/Loft.4.jpg';
import L5 from './images/Loft.5.jpg';
import L6 from './images/Loft.6.jpg';
import L7 from './images/Loft.7.jpg';
import L8 from './images/Loft.8.jpg';
import L9 from './images/Loft.9.jpg';

const Loft = () => {

  const images = [
    { original: L1, thumbnail: L1 },
    { original: L2, thumbnail: L2 },
    { original: L3, thumbnail: L3 },
    { original: L4, thumbnail: L4 },
    { original: L5, thumbnail: L5 },
    { original: L6, thumbnail: L6 },
    { original: L7, thumbnail: L7 },
    { original: L8, thumbnail: L8 },
    { original: L9, thumbnail: L9 },
  ];

  return (
    <Room title="Loft" images={images} capacity={4}>
      <p className="p-services">Nuestro Loft esta diseñado con un concepto moderno y minimalista, manteniendo la idea estètica de la Posada.</p>
      <p className="p-services">Pensado para alojamientos prolongados o para disfrutar de la Posada manteniéndose aislado de los movimientos del resto de los pasajeros.</p>
      <p className="p-services">Cuenta dentro de sus servicios con una cocina totalmente equipada además de WiFi, Aire Acondicionado, ventilador de techo, TV LCD con cable</p>
    </Room>
  );
};

export default Loft;



// WEBPACK FOOTER //
// ./src/rooms/loft/index.js